import { ActivitiesService } from 'app/_services/activities.service';
import * as angular from 'angular';

class StaSummaryComponentCtrl implements ng.IController {
    activities: any[];
    filterCompletelyWon: any;
    filterPartiallyWon: any;
    filterLost: any;

    constructor(
        private Activity,
        private activitiesService: ActivitiesService
    ) {}

    $onInit() {
        this.activities = [];
        this.filterCompletelyWon = {
            state: this.activitiesService.STATE.COMPLETELY_WON,
            categories: [],
            networkPoints: [],
            from: null,
            to: null
        };
        this.filterPartiallyWon = {
            state: this.activitiesService.STATE.PARTIALLY_WON,
            categories: [],
            networkPoints: [],
            from: null,
            to: null
        };
        this.filterLost = {
            state: this.activitiesService.STATE.LOST,
            categories: [],
            networkPoints: [],
            from: null,
            to: null
        };

        this.Activity.query(
            { category: [this.activitiesService.CATEGORY.SHORT_TERM_AUCTION] },
            (res) => {
                this.activities = this.activitiesService.map(
                    res.data
                ).activities;
            }
        );
    }
}

angular.module('app').component('pkpStaSummary', {
    controller: StaSummaryComponentCtrl,
    template: require('app/auctions-list/sta-summary.component.html'),
    bindings: {}
});
